<template>
  <div class="box13">
    <div class="titleBox">
      <div class="title">顺势而为 你也可以</div>
      <div class="subtitle">现在仍是入行好时机！</div>
    </div>
    <div class="itemBox">
      <div class="item" v-for="(item, index) in list" :key="index">
        <img
          :src="
            require(`../../../assets/coursePage/media/box13/${index + 1}.png`)
          "
          alt=""
        />
        <p class="title">{{ item.title }}</p>
        <p class="info">{{ item.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          title: "不便进入职场人群",
          text: "宝妈、退休老人等不具备进入职场条件的人群，在家也能玩网络，创收入！",
        },
        {
          title: "具备某方面能力特长人群",
          text: "在某领域有一定特长或经验，有明显个性化特征的人群，更容易快速上手。",
        },
        {
          title: "创业者/向往自由的人群",
          text: "有一定产业链，无运营能力，需快速推广创收人群。追求更灵活、更自由轻松工作环境的自由职业者。",
        },
        {
          title: "初入职场迷茫者",
          text: "初入新媒体行业，把控不了准确的运营节奏，需要专业人士陪跑指导，快速升职加薪。",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box13 {
  padding: 0px 30px 58px;
  box-sizing: border-box;
  width: 100%;
  background: url("../../../assets/coursePage/media/box13/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .titleBox {
    text-align: center;
    margin-top: 80px;
    .title {
      font-size: 40px;
      font-family: PingFangSC-Semibold;
      font-weight: 500;
      color: #0d004d;
      line-height: 62px;
    }
    .subtitle {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #555266;
      line-height: 40px;
      margin-top: 10px;
      margin-bottom: 48px;
    }
  }
}
.itemBox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.item {
  width: 330px;

  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 5px 35px 0px rgba(148, 129, 255, 0.2);
  border-radius: 14px;

  box-sizing: border-box;
  margin-bottom: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  align-content: flex-start;
  img {
    width: 88px;
    height: 99px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 239px;
  }
  .title {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #0d004d;
    line-height: 36px;
    margin-top: 163px;
  }
  .info {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #555266;
    line-height: 40px;
    padding: 0 18px;
    box-sizing: border-box;
    text-align: center;
    margin-top: 18px;
    padding-bottom: 35px;
  }
}
.item:nth-child(3) {
  img {
    bottom: 275px;
  }
}
.item:nth-child(4) {
  img {
    bottom: 275px;
  }
  .info {
    padding: 0 23px;
  }
}
</style>
